<template>
    <div class="container-fluid">
        <loading :active.sync="bool_fullLoading"></loading>

        <div class="pageHeader">
            <h2 id="titleHeight">{{ this.getUserInfo.DN }}'s {{this.getLanguage["PF"]["PS"]}}</h2>
        </div>
        <div class="contentWrapper">
            <div class="row mx-5 py-2">
                <div class="col-md-2 text-center mx-2 py-1" :class="{'bg-secondary': selected_menu == 1}" style="border-radius: 8px; border: 1px solid lightgray; cursor: pointer;" @click="selected_menu = 1">
                    <span style="display: block;" class="my-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                        </svg>
                    </span>
                    <span class="fw-bold">{{this.getLanguage["PF"]["PI"]}}</span>
                </div>
                <div class="col-md-2 text-center mx-2 py-1" :class="{'bg-secondary': selected_menu == 2}" style="border-radius: 8px; cursor: pointer; border: 1px solid lightgray; cursor: pointer;" @click="selected_menu = 2">
                    <span style="display: block;" class="my-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-card-list" viewBox="0 0 16 16">
                            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
                            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8m0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
                        </svg>
                    </span>
                    <span class="fw-bold">{{this.getLanguage["PF"]["CUSM"]}}</span>
                </div>
            </div>
        </div>
        <div class="contentWrapper">
            <div class="row m-4">
                <div class="col-md-12" v-if="selected_menu == 1">
                    <div class="form-group row py-4">
                        <div class="col-sm-12">
                            <h3 class="font-weight-bold mb-0">{{this.getLanguage["PF"]["PI"]}}</h3>
                            <small>{{this.getLanguage["PF"]["PD"]}}</small>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UDN']}}</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" :placeholder="getLanguage['AG']['UDN']" v-model="obj_P.DN">
                            <span class="ErrMsg">{{ ValidationErrMsg('DN', 'UDN') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>
                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['OP']}}</label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['OP']" v-model="obj_P.OP">
                            <span class="ErrMsg">{{ ValidationErrMsg('OP', 'OP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>
                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">
                            {{getLanguage['AG']['UUP']}} <div class="custom-tooltip" style="position: unset;">
                                <i class="fa fa-question-circle"></i>
                                <span class="custom-tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                            </div>
                        </label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['UUP']" v-model="obj_P.UP">
                            <span class="ErrMsg">{{ ValidationErrMsg('UP', 'UUP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UCUP']}}</label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['UCUP']" v-model="obj_P.CUP">
                            <span class="ErrMsg">{{ ValidationErrMsg('CUP', 'UCUP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UE']}}</label>
                        <div class="col-sm-8">
                            <input type="email" class="form-control" :placeholder="getLanguage['AG']['UE']" v-model="obj_P.E">
                            <span class="ErrMsg">{{ ValidationErrMsg('E', 'UE') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UPN']}}</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" :placeholder="getLanguage['AG']['UPN']" v-model="obj_P.PN">
                        </div>
                    </div>

                    <div style="margin:20px 0;text-align:center">
                        <CButton color="info" block @click="saveProfile()">
                            <span class='plusIcon cil-plus'></span>
                            {{this.getLanguage["BTN"]["SV"]}}
                        </CButton>
                    </div>
                </div>
                <div class="col-md-12" v-if="selected_menu == 2">
                    <div class="form-group row pt-4">
                        <div class="col-sm-12">
                            <h3 class="font-weight-bold mb-0">{{this.getLanguage["PF"]["CM"]}}</h3>
                            <small>{{this.getLanguage["PF"]["CMD"]}}</small>
                        </div>
                    </div>
                    <div class='subHeaderHR pb-2'></div>
                    <CSidebar style="position: relative" class="py-2">
                        <div class="scroll">
                            <ul class="c-scroll-area c-sidebar-nav ps" style="position: relative;z-index: 5;">
                                <template v-for="(menuTitle, index) in obj_menuTitle">
                                    <li v-if="menuTitle.C == false && checkMenuAccess(menuTitle.MN) && menuTitle.HSM == false" class="c-sidebar-nav-dropdown" :class="[(showSubMenu == menuTitle.MN ? 'c-show' : ''),(showActiveMenu.includes(menuTitle.PM)  || (showSubSubMenu && (menuTitle.PM == 'R' || menuTitle.PM == 'P' || menuTitle.PM == 'AGS' || menuTitle.PM == 'WEBS'|| menuTitle.PM == 'TOOLS' )) ? 'activeLvl1' : '')]">
                                        <a class="c-sidebar-nav-dropdown-toggle" v-if="menuTitle.HSM == false" v-on:click="changeShowSubMenu(menuTitle.MN)">
                                            <i :class="renderIcon(menuTitle.MN)"></i>
                                            <div class="menu-Name">
                                                <span>{{ menuTitle.MPI }}.</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                                            </div>
                                        </a>
                                        <ul class="c-sidebar-nav-dropdown-items">
                                            <template v-for="(menuSubmenu, index) in obj_menuTitle">
                                                <span v-if="menuSubmenu.C && menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == false">
                                                <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.ISF != true && menuSubmenu.MN != 'VEC' && menuSubmenu.MN != 'VEB' && menuSubmenu.MN != 'VDH' && menuSubmenu.MN != 'CRMDU' && menuSubmenu.MN != 'LCHAT' && menuSubmenu.MN != 'UM'  && menuSubmenu.MN != 'VG' && menuSubmenu.MN != 'SAGTWL' && menuSubmenu.MN != 'STWO' && menuSubmenu.MN != 'VOTSB' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN && (showSubSubMenu !='RS6')}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.MN) }}</span>
                                                            <span>
                                                                <span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span>
                                                                <input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" />
                                                            </span>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'SAGTWL' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span v-if="getUserInfo.AT === 4">{{ getLanguage["SMB"]["NTWL"] }}</span>
                                                            <span v-else>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>

                                                <li class="c-sidebar-nav-item" v-else-if="(menuTitle.MN == 'D' || menuTitle.MN == 'W' || menuTitle.MN == 'P') && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.add)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.add) }}</span>
                                                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>

                                                <li class="c-sidebar-nav-item" v-else-if="((menuSubmenu.MN == 'VG') || (menuSubmenu.MN == 'UM')) && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>
                                                </span>
                                                <span v-if="menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == true && menuSubmenu.SMN.length > 0 && checkSubModuleAccess(menuSubmenu.SMN)">
                                                <li class="c-sidebar-nav-item c-sidebar-nav-dropdown" v-if="checkMenuAccess(menuSubmenu.MN)" v-on:click="changeShowSubSubMenu(menuSubmenu.SMN)" :class="[((showSubSubMenu == menuSubmenu.SMN)  ? 'menuActive c-show' : ''),(showSubSubMenu.includes(menuTitle.SPM) ? 'activeLvl2' : '')]" style="cursor:pointer">
                                                    <div class="activeLvl2Div">
                                                        <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link c-sidebar-nav-dropdown-toggle haveSubMenu" target="_self">
                                                            <div class="dropdown-Name">
                                                                <span>{{ checkSubModuleIndex(menuSubmenu.MPI, menuSubmenu.PM, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.SMN) }}</span>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </li>
                                                <template v-for="(menuSubModulemenu, index) in obj_menuTitle">
                                                    <span class="level3" v-if="menuSubModulemenu.C && menuSubModulemenu.SPM == menuSubmenu.SMN && menuSubModulemenu.HSM == true">
                                                    <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view)" v-on:click="changeShowActiveMenu(menuSubModulemenu.PM + '.' + menuSubModulemenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubModulemenu.MN, 'd-block': showSubSubMenu == menuSubModulemenu.SPM, 'd-none': showSubSubMenu != menuSubModulemenu.SPM}" style="animation: fadeIn .5s; ">
                                                        <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubModulemenu.IHM = !menuSubModulemenu.IHM">
                                                            <div class="dropdown-Name dropdown-SubName">
                                                                <span>{{ checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                                <span v-if="menuSubModulemenu.MN == 'DR2'">{{ getLanguageOEMI(int_OEMId,"SMB","D") }}</span>
                                                                <span v-else-if="menuSubModulemenu.MN == 'WR2'">{{ getLanguageOEMI(int_OEMId,"SMB","W") }}</span>
                                                                <span v-else>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubModulemenu.MN) }}</span>
                                                                <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubModulemenu.IHM" /></span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    </span>
                                                </template>
                                                </span>
                                            </template>
                                        </ul>
                                    </li>

                                    <!-- custom for promo rules only (simplify menu) -->
                                    <li v-if="menuTitle.C == false && (menuTitle.MN == 'PRS' && menuTitle.PM == 'PRS') && menuTitle.HSM == false" :class="[(showSubMenu == menuTitle.MN ? 'c-sidebar-nav-dropdown c-show' : '')]">
                                        <a href="javascript:void(0)" class="c-sidebar-nav-dropdown-toggle after-none" @click="menuTitle.IHM = !menuTitle.IHM">
                                            <i :class="renderIcon(menuTitle.MN)"></i>
                                            <div class="menu-Name">
                                                <span>{{ menuTitle.MPI }}.</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                                            </div>
                                            <div><input id="profile_checkbox" type="checkbox" style="height: 14px; width: 14px; margin-top: 1px; position: absolute; right: 15px; top: 7px; accent-color: #321fdb" :checked="!menuTitle.IHM" /></div>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </CSidebar>
                    <div style="margin:20px 0;text-align:center">
                        <CButton color="info" block @click="saveMenu()">
                            <span class='plusIcon cil-plus'></span>
                            {{this.getLanguage["BTN"]["SV"]}}
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import { required, sameAs, requiredIf, minLength, email } from "vuelidate/lib/validators";
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from "vue-loading-overlay";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { constAccessType, constMenuIcon } from '@/modules/Constant.js';

    function validatePassword(value) {
        if (this.obj_P.UP != null && this.obj_P.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_P.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),
            isSimpleMode() {
                return this.$parent.isSimpleMode;
            },
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                obj_P: {},
                selected_menu: 1,
                obj_menuTitle: {},
                constAccessType: constAccessType,
                constMenuIcon: constMenuIcon,
                int_OEMId: 0,
                minimize: false,
                isminimize: false,
                showSubMenu: "-1",
                showSubSubMenu: "-1",
                showActiveMenu: "-1",
                bool_fullpageLoading: false
            }
        },
        validations: {
            obj_P: {
                U: { required },
                DN: { required },
                E: { email },
                OP: {
                    required: requiredIf(function (vm) {
                        return vm.UP != '';
                    }),
                },
                UP: {
                    minLength: value => !value || minLength(6)(value), validatePassword
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                }
            }, 
        },
        methods: {
            ...mapActions('UserInfo', ['setUser', 'setMenuDisplayType']),
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_P[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage['PF']['ERRMIN'];
                        }
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            getProfile() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/0`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setProfileData(d.D);
                    }
                });
            },
            setProfileData(data) {
                var agi;
                this.obj_P = data;
                this.obj_P.UP = '';

                agi = (this.obj_P.AT == 4) ? this.obj_P.SAGAGI : this.obj_P.AGI;
                this.obj_P.ATAGI = this.obj_P.AT + "-" + agi;
            },
            saveProfile() {
                this.bool_CV = true;
                this.$v.obj_P.$touch();
                if (!this.$v.obj_P.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    this.obj_P.IPF = 1;
                    this.postDataApi(`/api/agt/s`, this.obj_P, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getProfile();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
                }
            },
            getmenuTitle(isSimpleMode) {
                var that = this;
                this.getDataApi(`/api/role/gv/0/0/` + isSimpleMode,
                    function (d, s) {
                        if (s) {
                            that.setmenuTitle(d);
                        }
                    });
            },
            setmenuTitle(data) {
                this.obj_menuTitle = data.RoleAccessList;
                if (this.isOUTMOB) {
                    var that = this;
                    var tempMenu = []; // temperory hide menu in outlet mobile
                    $.each(that.obj_menuTitle, function (index, elem) {
                        if (elem.PM == "DASH" || elem.PM == "P" || (elem.PM == "R" && elem.SMN == "RS2") || (elem.PM == "R" && elem.MN == "WINLV2") || (elem.PM == "R" && elem.MN == "SAGTWL") || (elem.PM == "R" && elem.SMN == "RS4") || elem.PM == "AFF" || elem.PM == "MS" || elem.PM == "L" || elem.PM == "D" || elem.PM == "W" || (elem.PM == "M" && elem.MN == "BLL") || (elem.PM == "GS" && elem.MN == "GSDU") || (elem.PM == "AGS" && elem.MN == "SUBHRY") || elem.ISF == true) {
                        } else {
                            tempMenu.push(elem)
                        }
                    });
                    that.obj_menuTitle = tempMenu;
                }

                if (this.$route.path == "/") {
                    var ParentModule = "";
                    var ModuleName = "";
                    for (var i = 0; i < this.obj_menuTitle.length; i++) {
                        if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB') {
                            var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                            ParentModule = this.obj_menuTitle[i].PM;
                            ModuleName = this.obj_menuTitle[i].MN;
                            this.$router.push(link);
                            break;
                        }
                    }
                    //this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                } else {
                    var temp = this.showActiveMenu.split('.');
                    var ParentModule = "";
                    var ModuleName = "";
                    if (temp.length > 0) {
                        ParentModule = temp[0];
                        ModuleName = temp[1];
                    }
                    //this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                }

                for (var i = 0; i < this.obj_menuTitle.length; i++) {
                    if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB' && this.obj_menuTitle[i].ISF == false) {
                        var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                        this.FisrtMenuItem = link;
                        break;
                    }
                }
                this.bool_fullpageLoading = false;
            },
            renderIcon(menuTitle) {
                return this.constMenuIcon[menuTitle];
            },

            changeShowSubMenu(MN) {
                this.$route.matched[0].name = this.getLanguage["SMB"][MN];

                if (this.showSubMenu == MN) {
                    this.showSubMenu = '';
                } else {
                    this.showSubMenu = MN;
                }
               // this.isFirstLoad = false;
            },
            changeShowSubSubMenu(SMN) {
                if (this.showSubSubMenu == SMN) {
                    this.showSubSubMenu = '';
                } else {
                    this.showSubSubMenu = SMN;
                }
            },
            changeShowActiveMenu(MN) {
                this.showActiveMenu = MN;

                if (this.showSubSubMenu == 'RS6' && this.showSubMenu != 'GS') {
                    this.showSubSubMenu = '';
                }

                if (!this.isOUTMOB) {
                    if (!this.showSubSubMenu) {
                        this.changeShowSubSubMenu('RS1')
                    }
                }
                else {
                    this.changeShowSubSubMenu('RS3')
                }


                //Game Settings collapse sub menu when click on other menu
                if (MN.split(".")[0] == "GS" && (
                    MN.split(".")[1] != "GPS" && MN.split(".")[1] != "M888S" &&
                    MN.split(".")[1] != "MV3S" && MN.split(".")[1] != "P888S" &&
                    MN.split(".")[1] != "K918S" && MN.split(".")[1] != "A288S" &&
                    MN.split(".")[1] != "AFBCS" && MN.split(".")[1] != "LG88S" &&
                    MN.split(".")[1] != "GD88S" && MN.split(".")[1] != "IGS" &&
                    MN.split(".")[1] != "NKS" && MN.split(".")[1] != "W9S"
                )) {
                    if (!this.isOUTMOB) {
                        this.changeShowSubSubMenu('RS1');
                    }
                    else {
                        this.changeShowSubSubMenu('RS3');
                    }
                }


                // when click report will auto minimize sidemenu
                if (MN.split(".")[0] == "R") {
                    this.isminimize = true;
                    this.minimize = true;
                } else {
                    this.isminimize = false;
                    this.minimize = false;
                }
            },
           
            saveMenu() {
                let hidden_menu_list = this.obj_menuTitle.filter(f => { return f.IHM == true && (f.PM != f.MN || f.MN == 'PRS') });
                let str_menu_list = "";
                if (hidden_menu_list && hidden_menu_list.length > 0) {
                    let ParentModuleList = [];
                    for (var i = 0; i < hidden_menu_list.length; i++) {
                        str_menu_list += (hidden_menu_list[i].PM + "[1]" + hidden_menu_list[i].MN + "[2]" + hidden_menu_list[i].SPM + "[3]" + hidden_menu_list[i].SMN + ",");
                        if (!ParentModuleList.includes(hidden_menu_list[i].PM + "#" + hidden_menu_list[i].SPM) && hidden_menu_list[i].PM != hidden_menu_list[i].MN)
                            ParentModuleList.push(hidden_menu_list[i].PM + "#" + hidden_menu_list[i].SPM);
                    }
                    if (ParentModuleList && ParentModuleList.length > 0) {
                        // Hide parent module if all sub modules are hide
                        for (var i = 0; i < ParentModuleList.length; i++) {
                            let ArrayStr = ParentModuleList[i].split("#");
                            let parentModule = this.obj_menuTitle.find(f => { return f.IHM == false && f.PM == ArrayStr[0] && f.MN != ArrayStr[0] && ((ArrayStr[1] && f.SPM == ArrayStr[1]) || !ArrayStr[1]) && f.SPI > 0 && !f.ISF && this.checkModuleAccess(f.MN, f.PM, constAccessType.view) });
                            if (parentModule == undefined) {
                                str_menu_list += (ArrayStr[0] + "[1]" + ArrayStr[0] + "[2][3]" + ArrayStr[1] + ",");
                            }
                        }

                        // Hide report menu if no submenu
                        let parentModule = this.obj_menuTitle.find(f => { return f.IHM == false && f.PM == "R" && f.SPM != '' && f.SPI > 0 && !f.ISF && this.checkModuleAccess(f.MN, f.PM, constAccessType.view) });
                        if (parentModule == undefined) {
                            str_menu_list += ("R[1]R[2][3]" + ",");
                        }
                    }
                    str_menu_list = str_menu_list.slice(0, -1);
                }

                this.bool_fullLoading = true;
                var that = this;
                this.postDataApi(`/api/role/hidemenu`, { 'IHM': this.isSimpleMode, 'MN': str_menu_list },
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            window.location.reload();
                        }
                    });
            }
        },
        created() {
            this.selected_menu = 1;
            this.int_OEMId = this.getUserInfo.OEMI;
            this.getProfile();
        },
        mounted() {
            if (localStorage.getItem('isSimpleMode') === 'False') {
                this.setMenuDisplayType(0)
                this.getmenuTitle(0);
            } else {
                this.setMenuDisplayType(1)
                this.getmenuTitle(1);
            }
            this.changeShowActiveMenu(this.$parent.showActiveMenu);
        },
        watch: {
            isSimpleMode() {
                this.obj_menuTitle = {};
                this.bool_fullpageLoading = true;
                if (this.isSimpleMode) {
                    localStorage.setItem('isSimpleMode', 'True');
                    this.setMenuDisplayType(1)
                    this.getmenuTitle(1);
                } else {
                    localStorage.setItem('isSimpleMode', 'False');
                    this.setMenuDisplayType(0)
                    this.getmenuTitle(0);
                }
            },
        },
    }

</script>

<style>
    .contentWrapper {
        background: #fff;
        width: 100%;
        margin-top: 1rem;
        margin-left: -15px;
        margin-right: -15px;
    }


    .col-form-label {
        font-weight: bold;
    }

    input[type="checkbox"]#profile_checkbox {
        -webkit-appearance: none; /* Remove default styles for WebKit browsers */
        -moz-appearance: none; /* Remove default styles for Firefox */
        appearance: none;
        width: 16px;
        height: 16px;
        background-color: #f0f0f0; /* Default background color */
        border: 1px solid #ccc;
        border-radius: 2px;
        cursor: pointer;
        margin-top: 1px;
    }

        input[type="checkbox"]#profile_checkbox:checked {
            background-color: rgb(50, 31, 219); /* Background color when checked */
            border-color: rgb(50, 31, 219);
        }

    input[type="checkbox"]#profile_checkbox:checked::before {
        content: "\2713"; /* Unicode for checkmark */
        display: block;
        text-align: center;
        color: white;
        font-size: 14px;
        line-height: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page/Profile.vue